import React, { useState, useRef } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  makeStyles,
  TextareaAutosize,
  CircularProgress
} from "@material-ui/core";
import { Button, Container, Row, Col, FormLabel } from "react-bootstrap";
import { CloudUpload as CloudUploadIcon } from "@material-ui/icons";
import ProgramTable from "./_components/TableComponent";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import { AddProgramAPI, GetProgram, GetSocCode, UpdateProgramAPI } from "../api";
import { useParams } from 'react-router-dom'
import Preview from "../_components/preview"
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Select from "react-select";

const useStyles = makeStyles((theme) => ({
  main: {
    background: "#F3F3F3",
    borderRadius: "8px",
    padding: "5px",
  },
  uploadContainer: {
    padding: theme.spacing(4),
    textAlign: "center",
    borderRadius: theme.shape.borderRadius,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  uploadAside: {
    background: "#fff",
    borderRadius: "8px",
  },
  uploadIcon: {
    fontSize: "40px",
    color: theme.palette.primary.main,
  },
  uploadText: {
    margin: theme.spacing(2, 0),
  },
  uploadButton: {
    marginTop: theme.spacing(2),
  },
  formContainer: {
    padding: theme.spacing(3),
    textAlign: "center",
  },
  logo: {
    marginBottom: theme.spacing(2),
  },
  inputField: {
    marginBottom: theme.spacing(2),
  },
  labelField: {
    fontSize: "22px",
    fontWeight: 700,
  },
  labelField2: {
    fontSize: "16px",
    fontWeight: 600,
  },
  labelField3: {
    fontSize: "15px",
    fontWeight: 600,
    marginBottom: "0px",
  },
}));
const AddProgram = () => {
  const classes = useStyles();

  const { id } = useParams(); 

  const { user } = useSelector(({ auth }) => auth, shallowEqual);

  const navigate = useHistory();
  

  const [program, setProgram] = React.useState({
    _id: null,
    industry_id: null,
    industry_name: null,
    program_code: null,
    program_title: null,
    program_subtitle: null,
    org: user.organization,  // Assuming this will be an ObjectId
    program_image_url: null,
    estimated_time: null,
    learning_model: null,
    course_type: null,
    soc_code: null,
    total_cost: 0,
    program_description: null,
    program_objective: null,
    general_requirements: null,
    technical_requirements: null,
    course_materials: null,
    program_session: null,
    start_date: null,
    end_date: null,
    drop_date: null,
    add_date: null,
    terms_date: null,
    additional_costs: null,
    career_opportunities: null,
    program_outcomes: null,
    instructors: null,
    recommended_programs: [],  // Assuming this will be an array of ObjectIds
    program_status: true,
    public: true
  });

  const [socCodeOptions, setSocCodeOptions] = useState([]);

  const [loading, setLoading] = React.useState(true);

  const [pending, setPending] = React.useState(false);

  const handleSave = async () => {
    if(!program.program_title){
      alert("Program Title is required");
      return;
    }
    if (!program.industry_name) {
      alert("Industry is required");
      return;
    }
    
    if (program.total_cost <= 0) {
      alert("Cost must be greater than 0");
      return;
    }
    // console.log(program);
    // return ;
    try{
      setPending(true);
      const formData = new FormData(); 
      for (const key in program) {
        if (program.hasOwnProperty(key)) {
          if(program[key] != null){
            if(key == 'recommended_programs'){
              program.recommended_programs.forEach(id => {
                formData.append("recommended_programs[]", id)
              })
            }else{
              formData.append(key, program[key]);
            }
          }
        }
      }
      let res = await UpdateProgramAPI(formData);
      navigate.push('/programs');
    }catch(ex){
      console.log(ex);
      let error = ex.response ? ex.reponse.data.message : ex.message;
      alert(error);
    }finally{
      setPending(false);
    }
  }

  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    setProgram((pre) => ({
      ...pre,
      [name]: value
    }))
  }

  const handleGetProgram = async () => {
    try{
      setLoading(true);
      let res = await GetProgram(id);
      setProgram((pre)=>({
        ...pre,
        ...res.data.data,
        org: user.organization
      }));
      setLoading(false);
    }catch(ex){
      console.log(ex);
    }
  }

  const fetchSocCodes = async () => {
      try {
        const response = await GetSocCode();
        const options = response.data.map((code) => {
          return { value: code, label: code };
        })
        console.log("Fetched SOC Codes:", options);
        
        setSocCodeOptions(options);
      }catch(ex){
        console.error("Error fetching SOC codes:", ex);
      }
    }

  React.useEffect(()=>{
    console.log(id, '==========================');
    handleGetProgram();
    fetchSocCodes();
  }, [])

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [dragging, setDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false);
    console.log(event.dataTransfer.files, '============= files =============');
    const droppedFiles = event.dataTransfer.files;
    // console.log(droppedFiles);
    const allowedTypes = ['image/jpeg', 'image/png'];

    if (!allowedTypes.includes(droppedFiles[0].type)) { 
      alert("Only JPEG and PNG files are allowed.");
      return ;
    }
    setProgram((pre)=>({
      ...pre,
      file: droppedFiles[0],
      program_image_url: URL.createObjectURL(droppedFiles[0])
    }))
    // setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
  };

  const handleFileUpload = (event) => {
    const uploadedFiles = event.target.files;
    // console.log(uploadedFiles);
    const allowedTypes = ['image/jpeg', 'image/png'];

    if (!allowedTypes.includes(uploadedFiles[0].type)) { 
      alert("Only JPEG and PNG files are allowed.");
      return ;
    }
    setProgram((pre)=>({
      ...pre,
      file: uploadedFiles[0],
      program_image_url: URL.createObjectURL(uploadedFiles[0])
    }))
    // setFiles((prevFiles) => [...prevFiles, ...uploadedFiles]);
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div>
      {loading ? <Box className="py-1">
                      <CircularProgress />
                    </Box> : <>
        <Box className={classes.main}>
          <Grid container direction="col">
            <Grid item md={6} sm={12} className={classes.uploadAside}>
            <Box
              className={`${classes.uploadContainer} ${
                dragging ? classes.dragging : ""
              }`}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <CloudUploadIcon className={classes.uploadIcon} />
              <Typography variant="h6" className={classes.uploadText}>
                Drag and drop files here
              </Typography>
              <Typography variant="body2">or</Typography>
              <Button
                variant="primary"
                className={classes.uploadButton}
                onClick={handleButtonClick}
              >
                <input
                  type="file"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleFileUpload}
                />
                Upload file
              </Button>
              {program.file && (
                <Typography
                  variant="body2"
                  className={classes.uploadedFilesText}
                >
                  {program.file.name} file uploaded
                </Typography>
              )}
            </Box>
            </Grid>
            <Grid item md={6} sm={12}>
              <Container className={classes.formContainer}>
                <img
                  src="https://cdn.pixabay.com/photo/2016/11/07/13/04/yoga-1805784_640.png"
                  alt="Pangea Learning"
                  width={40}
                  className={classes.logo}
                />
                <Row>
                  <Col>
                    <TextField
                      label="Program Code"
                      variant="outlined"
                      fullWidth
                      className={classes.inputField}
                      value={program.program_code}
                      onChange={handleInput}
                      name="program_code"
                    />
                  </Col>
                  <Col>
                    <TextField
                      label="Program Title"
                      variant="outlined"
                      fullWidth
                      className={classes.inputField}
                      value={program.program_title}
                      onChange={handleInput}
                      name="program_title"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <TextField
                      label="Program Subtitle"
                      variant="outlined"
                      fullWidth
                      className={classes.inputField}
                      value={program.program_subtitle}
                      onChange={handleInput}
                      name="program_subtitle"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {/* <TextField
                      label="Soc Code"
                      variant="outlined"
                      fullWidth
                      className={classes.inputField}
                      value={program.soc_code}
                      onChange={handleInput}
                      name="soc_code"
                    /> */}
                    <Select
                      placeholder="SOC Code"
                      options={socCodeOptions} // [{ value: '1234', label: '1234' }, ...]
                      value={program.soc_code ? { value: program.soc_code, label: program.soc_code } : null}
                      onChange={(selectedOption) => 
                        handleInput({
                          target: { name: "soc_code", value: selectedOption?.value || "" }
                        })
                      }
                      isSearchable
                      className={"program-soc-code-select"}
                    />
                  </Col>
                  <Col>
                    <TextField
                      label="Industry"
                      variant="outlined"
                      fullWidth
                      className={classes.inputField}
                      value={program.industry_name}
                      onChange={handleInput}
                      name="industry_name"
                    />
                  </Col>
                </Row>
              </Container>
            </Grid>
          </Grid>
        </Box>
        <Container className="mt-5 px-0">
          <Row>
            <Col>
              <TextField
                label="Estimate Time"
                variant="outlined"
                fullWidth
                className={classes.inputField}
                value={program.estimated_time}
                onChange={handleInput}
                name="estimated_time"
              />
            </Col>
            <Col>
              <TextField
                label="Learning Model"
                variant="outlined"
                fullWidth
                className={classes.inputField}
                value={program.learning_model}
                onChange={handleInput}
                name="learning_model"
              />
            </Col>
            <Col>
              <TextField
                label="Course Type"
                variant="outlined"
                fullWidth
                className={classes.inputField}
                value={program.course_type}
                onChange={handleInput}
                name="course_type"
              />
            </Col>
            <Col>
              <TextField
                label="Total Costs"
                variant="outlined"
                fullWidth
                className={classes.inputField}
                type="number"
                value={program.total_cost}
                onChange={handleInput}
                name="total_cost"
              />
            </Col>
          </Row>
          <FormLabel className={classes.labelField}>Description</FormLabel>
          <Row className="px-5">
            <TextField
              label="Program Description"
              multiline
              rows={8}
              variant="outlined"
              fullWidth
              value={program.program_description}
              onChange={handleInput}
              name="program_description"
            />
          </Row>
          <Row spacing={5} className="mt-5">
            <Col>
              <FormLabel className={classes.labelField}>
                Program Objective
              </FormLabel>
              <TextField
                label="Program Objective"
                multiline
                rows={8}
                variant="outlined"
                fullWidth
                value={program.program_objective}
                onChange={handleInput}
                name="program_objective"
              />
              <Typography variant="h3" className={`mt-4 ${classes.labelField}`}>
                Requirements
              </Typography>
              <FormLabel className={classes.labelField2}>Prerequisites</FormLabel>
              <TextField
                label="Program Requirements"
                multiline
                rows={6}
                variant="outlined"
                fullWidth
                value={program.general_requirements}
                onChange={handleInput}
                name="general_requirements"
              />
              <FormLabel className={`mt-3 ${classes.labelField2}`}>
                Hardware Requirements
              </FormLabel>
              <TextField
                label="Hardware Requirement"
                multiline
                rows={6}
                variant="outlined"
                fullWidth
                value={program.technical_requirements}
                onChange={handleInput}
                name="technical_requirements"
              />
              <FormLabel className={`mt-3 ${classes.labelField}`}>
                Course Material
              </FormLabel>
              <TextField
                label="Course Material"
                multiline
                rows={6}
                variant="outlined"
                fullWidth
                value={program.course_materials}
                onChange={handleInput}
                name="course_materials"
              />
              <FormLabel className={`mt-3 ${classes.labelField}`}>
                Instructors
              </FormLabel>
              <TextField
                label="Instructors"
                multiline
                rows={6}
                variant="outlined"
                fullWidth
                value={program.instructors}
                onChange={handleInput}
                name="instructors"
              />
            </Col>

            {/* Right Side */}
            <Col>
              <FormLabel className={`mt-3 ${classes.labelField}`}>
                Enrollment Details
              </FormLabel>
              <Row>
                <Col>
                  <FormLabel className={classes.labelField3}>Term</FormLabel>
                  <TextField type="date" variant="outlined" fullWidth
                    value={program.terms_date}
                    onChange={handleInput}
                    name="terms_date"
                  />
                </Col>
                <Col>
                  <FormLabel className={classes.labelField3}>Session</FormLabel>
                  <TextField type="date" variant="outlined" fullWidth 
                    value={program.program_session}
                    onChange={handleInput}
                    name="program_session"
                  />
                </Col>
                <Col>
                  <FormLabel className={classes.labelField3}>Add Date</FormLabel>
                  <TextField type="date" variant="outlined" fullWidth 
                    value={program.add_date}
                    onChange={handleInput}
                    name="add_date"
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <FormLabel className={classes.labelField3}>
                    Start Date
                  </FormLabel>
                  <TextField type="date" variant="outlined" fullWidth
                    value={program.start_date}
                    onChange={handleInput}
                    name="start_date"
                  />
                </Col>
                <Col>
                  <FormLabel className={classes.labelField3}>End Date</FormLabel>
                  <TextField type="date" variant="outlined" fullWidth 
                    value={program.end_date}
                    onChange={handleInput}
                    name="end_date"
                  />
                </Col>
                <Col>
                  <FormLabel className={classes.labelField3}>Drop Date</FormLabel>
                  <TextField type="date" variant="outlined" fullWidth 
                    value={program.drop_date}
                    onChange={handleInput}
                    name="drop_date"
                  />
                </Col>
              </Row>
              <Typography variant="h3" className={`mt-8 ${classes.labelField}`}>
                Career Opportunities
              </Typography>
              <FormLabel className={classes.labelField2}>
                Career Opportunities
              </FormLabel>
              <TextField
                label="Career Opportunities"
                multiline
                rows={8}
                variant="outlined"
                fullWidth
                value={program.career_opportunities}
                onChange={handleInput}
                name="career_opportunities"
              />
              <FormLabel className={`mt-4 ${classes.labelField}`}>
                Outcomes
              </FormLabel>
              <TextField
                label="Outcomes"
                multiline
                rows={11}
                variant="outlined"
                fullWidth
                value={program.program_outcomes}
                onChange={handleInput}
                name="program_outcomes"
              />
              <FormLabel className={`mt-4 ${classes.labelField}`}>
                Additional Costs
              </FormLabel>
              <TextField
                label="Additional Costs"
                multiline
                rows={8}
                variant="outlined"
                fullWidth
                value={program.additional_costs}
                onChange={handleInput}
                name="additional_costs"
              />
            </Col>
          </Row>
          <Row className="px-4 mt-8">
            <ProgramTable program={program} setProgram={setProgram} />
          </Row>
          <div className="px-4">
            <Row
              className="py-12 mt-8"
              style={{
                background: "#F3F3F3",
                display: "flex",
                justifyContent: "Center",
                alignItems: "Center",
              }}
            >
              <Button disabled={pending} onClick={handleSave} variant="primary">
                {pending ? <>
                  <CircularProgress
                    size="20px"
                    style={{ color: "white" }}
                  />
                </> : "Update"}
              </Button>
              <Button style={{marginLeft: "10px"}} variant="primary" type="button" onClick={handleOpen}>
              Preview
            </Button>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="lg"
              fullWidth={true}
            >
              <DialogContent>
                <Preview program={program} />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
            </Row>
          </div>
        </Container>
      </>}
    </div>
  );
};

export default AddProgram;
